import React from "react";
import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs";

const BarChart = ({ data, selectedOption3 }) => {
  // Determine the data type
  const isMonthly = data?.data?.[0]?.weekStartDate !== undefined;
  const isWeekly =
    data?.data?.[0]?._id && typeof data?.data?.[0]?._id === "string";
  const isYearly = data?.data?.[0]?.month !== undefined;

  // Prepare categories based on data type
  const categories = isYearly
    ? data?.data?.map((item) => item?.month) // Use month names for yearly data
    : isMonthly
    ? data?.data?.map(
        (item) =>
          `${dayjs(item?.weekStartDate).format("MMM D")} - ${dayjs(
            item?.weekEndDate
          ).format("MMM D")}` // Weekly as "Sep 30 - Oct 6"
      )
    : isWeekly
    ? data?.data?.map((item) => dayjs(item?._id).format("MMM D")) // Weekly date
    : [dayjs().format("MMM D")]; // Default to today's date

  // Prepare series data
  const seriesData = data?.data?.map((item) =>
    selectedOption3 === "Score"
      ? item?.scoreData?.scoreTotal
      : selectedOption3 === "Hits"
      ? item?.hitsData?.hitsTotal
      : item?.passingData?.passingTotal
  );

  const chartData = {
    series: [
      {
        data: seriesData,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#FFFFFF"],
        },
        formatter: (val) => val,
      },
      xaxis: {
        categories,
        labels: {
          style: {
            colors: "#FFFFFF",
          },
        },
        axisBorder: {
          color: "#FFFFFF",
        },
        axisTicks: {
          color: "#FFFFFF",
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#FFFFFF",
          },
        },
      },
      grid: {
        borderColor: "rgba(255, 255, 255, 0.1)",
      },
      fill: {
        colors: ["#6DD37F"],
      },
      tooltip: {
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const gameData = data?.data?.[dataPointIndex];
          const averageScore = gameData?.scoreData?.scoreAvg || "N/A";
          const averageTotal = gameData?.scoreData?.scoreTotal || "N/A";
          const category = w.globals.labels[dataPointIndex];
          return `
            <div style="padding: 8px; background-color: #1E1E2F; color: #FFFFFF; border-radius: 4px;">
              <div><strong>${category}</strong></div>
              <div style="border-bottom: 1px solid #FFFFFF; margin: 4px 0;"></div>
              <div>Average score: ${averageScore}</div>
            </div>
          `;
        },
      },
    },
  };

  return (
    <div className="">
      {/* <p className="text-white text-base font-bold">Average score per
        {isYearly
          ? " year"
          : isMonthly
          ? " month"
          : isWeekly
          ? " week"
          : " day"}</p> */}
      <p className="text-white text-base font-bold">Average score per month</p>
      <div id="chart">
        {data?.data && data?.data?.length > 0 ? (
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
          />
        ) : (
          <div className="flex justify-center text-white py-10">
            <p>Data Not Found</p>
          </div>
        )}
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default BarChart;
